import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import giftProducts from "src/data/products-gift";
import formatCurrency from "src/lib/format-currency";
import {
  addProduct,
  removeProduct,
  editProduct,
} from "src/redux/gifts/actions";
import {
  getSelectedProducts,
  getGiftsTotal,
  getHasExpressDelivery,
  getGiftsSubTotal,
  getIsGiftOffer,
} from "src/redux/gifts/selectors";
import { LinkButton } from "src/react/components/link";
import ButtonsWrapper from "src/react/components/buttons-wrapper";
import { SectionLayout } from "src/react/layout";
import GiftsBasketItem from "./basket-item";

const GiftsBasket = ({
  total,
  selectedProducts,
  addProduct,
  editProduct,
  removeProduct,
  hasExpressDelivery,
  isGiftOffer,
  match = { path: "" },
}) => {
  const pathname = match.path.replace("/basket", "");
  return (
    <SectionLayout data-selector="GiftsBasket" title="Gifts Basket">
      {selectedProducts.map((product) => {
        const productId = product.id;
        const productData = giftProducts[productId];
        const quantity = product.options.length;

        return (
          <GiftsBasketItem
            key={productId}
            product={product}
            productData={productData}
            quantity={quantity}
            addProduct={() =>
              addProduct({
                productId,
                options: productData.optionsDefaults,
              })
            }
            removeProduct={(itemIndex) =>
              removeProduct({ productId, itemIndex })
            }
            editProduct={({ itemIndex, itemOptions }) =>
              editProduct({ productId, itemIndex, itemOptions })
            }
            isGiftOffer={isGiftOffer}
          />
        );
      })}
      <CheckoutWrapper>
        <Title>Summary</Title>
        <Total data-selector="GiftsBasket-Total">
          Total: {formatCurrency({ value: total })}
        </Total>
        {!hasExpressDelivery && <Extras>+ free delivery</Extras>}
      </CheckoutWrapper>
      <ButtonsWrapper align="center">
        <LinkButton
          data-selector="GiftsBasket-ContinueShopping"
          variant="outline"
          to={pathname}
        >
          Continue shopping
        </LinkButton>
        <LinkButton
          data-selector="GiftsBasket-Checkout"
          variant="primary"
          to={`${pathname}/checkout`}
        >
          Proceed to checkout
        </LinkButton>
      </ButtonsWrapper>
    </SectionLayout>
  );
};

const mapStateToProps = (state) => ({
  selectedProducts: getSelectedProducts(state),
  total: getGiftsTotal(state),
  hasExpressDelivery: getHasExpressDelivery(state),
  subTotal: getGiftsSubTotal(state),
  isGiftOffer: getIsGiftOffer(state),
});

const mapDispatchToProps = {
  addProduct,
  removeProduct,
  editProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftsBasket);

const CheckoutWrapper = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const Title = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  margin-bottom: 25px;
`;

const Total = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 5px;
`;

const Extras = styled.p`
  font-style: italic;
  font-size: 14px;
  margin-bottom: 5px;
`;
